import api from '@/api';
import { API_BASE_URL } from '..';
import {
  WorkOrderTrackingCalendar,
  WorkOrderTrackingCalendarComplement,
  WorkOrderTrackingCalendarQueryParams,
} from './Tracking.types';

const CONTROLLER_URL = `${API_BASE_URL}/workorders/Tracking/calendar`;

export async function listWorkOrdersTrackingCalendar(
  params?: WorkOrderTrackingCalendarQueryParams,
) {
  const result = (await api.get(CONTROLLER_URL, {
    ...params,
    complementOrigin: params?.complementOrigin?.toString(),
  })) as unknown;

  return result as WorkOrderTrackingCalendar[];
}

export async function getWorkOrderTrackingCalendarComplement(
  complementId?: number,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${complementId}`,
    {},
  )) as unknown;

  return result as WorkOrderTrackingCalendarComplement;
}
